module.exports = __webpack_public_path__ + "img/2.cc978d3c.png";